<template>
    <span v-tooltip:[anchor]="getPackageToolTipText(packageId)">
        <img :src="'/images/package-' + packageId + '.png'" alt="četnost">
    </span>
</template>

<script>
export default {
    props: {
        packageId: String,
        anchor: {
            type: String,
            default: 'left'
        }
    },
    setup() {
        const getPackageToolTipText = packageString => {
            switch (packageString) {
                case 'D': return '3x ročně (jaro, léto, podzim)';
                case 'P': return '2x ročně (jaro, podzim)';
                case 'B': return '1x ročně (jaro nebo podzim)';
                default: return '';
            }
        }

        return {
            getPackageToolTipText
        }
    }
}
</script>